import { useEffect, useId, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useHints } from './HintsProvider';
import { useEscapeLayer } from '../ui/Dialog';

/** Top-bar menu "Pomoc": the manual and the user's own hints switch. */
export function HelpMenu() {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const rootRef = useRef<HTMLDivElement>(null);
  const { enabled, setEnabled, loading } = useHints();
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname, location.hash]);

  useEffect(() => {
    if (!open) return;
    const onPointerDown = (e: PointerEvent) => {
      if (e.target instanceof Node && !rootRef.current?.contains(e.target) && !(e.target as Element).closest?.('.hint-pop')) setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [open]);
  // a menu: Escape only (a shown hint takes its Escape first)
  useEscapeLayer(() => {
    setOpen(false);
    rootRef.current?.querySelector<HTMLElement>('button[aria-controls]')?.focus();
  }, open);

  return (
    <div className="help-menu" ref={rootRef}>
      <button
        type="button"
        className="btn ghost small"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        Pomoc
      </button>
      {open && (
        <div className="help-panel" id={panelId}>
          <Link to="/instrukcja" className="help-item" data-feature-id="hints.manual">
            Instrukcja
          </Link>
          <button
            type="button"
            role="switch"
            aria-checked={enabled}
            className="help-item help-switch"
            data-feature-id="hints.settings"
            disabled={loading}
            onClick={() => setEnabled(!enabled)}
          >
            <span>Podpowiedzi</span>
            <span className="switch-track" aria-hidden="true">
              <span className="switch-thumb" />
            </span>
            <span className="switch-state">{enabled ? 'włączone' : 'wyłączone'}</span>
          </button>
        </div>
      )}
    </div>
  );
}
